import { useRef } from 'react'

interface TimeoutRef {
  current: NodeJS.Timeout
}

const isTimeoutRefType = (timeoutRef: unknown): timeoutRef is TimeoutRef => {
  return (timeoutRef as TimeoutRef)?.current !== undefined
}

export default function useDebounce<T>(fn: unknown, delay: number) {
  const timeoutRef: unknown = useRef(null)

  function debounceFn(...args: T[]) {
    if (isTimeoutRefType(timeoutRef)) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = setTimeout(() => {
        if (typeof fn === 'function') {
          fn(...args)
        }
      }, delay)
    }
  }

  return debounceFn
}
